import * as React from 'react';
import { TextFieldProps } from '@material-ui/core';
import { RoleProtectedInput } from '@app/shared/components/RoleBasedRoute/components/RoleProtectedInput';

export const MarginSystemLevelInput = (props: TextFieldProps) => {
  return <RoleProtectedInput {...props} fullWidth type="number" />;
};
